import React, { useEffect, useRef, useState } from 'react'
import { html } from 'lit-html'
import { useStateContext } from '../contexts/ContextProvider'
import { useNavigate } from 'react-router-dom'
import { signOutAsync, toastNotification } from '../utils/apiFunctions'
import { publicKbUrl } from '../utils/common'
import { HtmlEscapeUtils } from '../utils/HtmlEscapeUtils'

const Header = () => {
    const [fontSize, setFontSize] = useState("11");
    const { user } = useStateContext();
    const navigate = useNavigate();

    let headerRef = useRef();

    function renderDialogFooterWithThreeBtnsContent() {
        const footer = document.createElement('div');
    
        footer.innerHTML = `
          <div class='flex flex-row justify-between'>
            <gz-button id="confirm" type="full" color="negative">Logout</gz-button>
            <gz-button id="cancelAction" type="outline" color="secondary">cancel</gz-button>
          </div>
      `;
        return footer;
    }

    const createLogoutConfirmDialog = (wrapper) => {
        const dialogBody = document.createElement('div');

        const dialogFooter = renderDialogFooterWithThreeBtnsContent();

        const confirmBtn = dialogFooter.querySelector('#confirm');
        const cancelActionBtn = dialogFooter.querySelector('#cancelAction');

        const dialogConfigs = {
            headline: 'Are you sure you want to logout?',
            bodyContent: dialogBody,
            footerContent: dialogFooter,
            isOpen: true,
        };

        const dialog = window.globalThis.nirvana.dependencies.services.buildDialogElement(dialogConfigs, wrapper);

        if (cancelActionBtn) {
            cancelActionBtn.addEventListener('click', () => {
                dialog.dismiss();
            });
        }

        if (confirmBtn) {
            confirmBtn.addEventListener('click', async () => {
                dialog.dismiss();
                await signOutAsync();
                navigate('/unauthorized', { state: { isSignOut: true, tenantUrl: `${user?.tenantInfo.tenantUrl}` } });
                toastNotification('You have successfully logged out.', 'success', false);
            });
        }
    }

    const handleLogout = () => {
        createLogoutConfirmDialog();
    }

    const handleRedirectToKb = () => {
        window.open(publicKbUrl,'_blank');
    }

    const handleFont = (size) => {
        setFontSize(size);
    }

    useEffect(() => {
        headerRef.current.items = items;
    })

    const renderMyAccount = html`
<div class="my-2 flex flex-col items-center gap-2">
    <div id="userGreeting" class="pb-1 pl-2 border-b-1 border-r-neutral-500 w-full">
        <gz-text fontSize="${fontSize}">Welcome,</gz-text>
        <div class="flex flex-row justify-between items-center">
            <gz-text fontSize="${fontSize}">${HtmlEscapeUtils.htmlEncode(user?.userName)}</gz-text>
            <div class="mr-2 flex flex-row items-baseline">
                <span @click=${() => handleFont("11")} class="mb-2 cursor-pointer"><gz-text fontSize="9">A</gz-text></span>
                <span @click=${() => handleFont("13")} class="mb-1 cursor-pointer"><gz-text fontSize="11">A</gz-text></span>
                <span @click=${() => handleFont("16")} class="cursor-pointer"><gz-text fontSize="13">A</gz-text></span>
            </div>
        </div>
    </div>
    <div id="helpSupport" class="border-b-1 pb-2 pl-2 border-r-neutral-500 w-full">
        <span class="cursor-pointer" @click=${handleRedirectToKb}>
            <gz-text fontSize="${fontSize}">Help & Support</gz-text>
        </span>
    </div>
    <div id="logoutSection" class="pl-2 w-full">
        <span class="cursor-pointer" @click=${handleLogout}>
            <gz-text fontSize="${fontSize}">Logout</gz-text>
        </span>
    </div>
</div>`

const items = [
    {
        id: 'myAccount',
        icon: 'ds-icon-user_menu',
        name: 'User role',
        isActive: false,
        isVisible: true,
        content: renderMyAccount
    },
    {
        id: 'whatsNew',
        icon: 'ds-icon-whats_new',
        name: `What's new`,
        isActive: false,
        isVisible: true,
        //handler: () => showWhatsNew(),
    },
    {
        id: 'notifications',
        icon: 'ds-icon-notification_bell',
        name: 'Notifications',
        isActive: false,
        isVisible: true,
        //handler: () => toggleHelpMode(),
    }
  ];

    return (
        <gz-header-ui ref={headerRef} style={{ float: "right" }}></gz-header-ui>
    )
}

export default Header